import { apiRequest, handleCall } from 'syft-acp-core/api/call'

import { FetchWorkerShiftsInput } from './types'

export const fetchWorkerShifts = ({ workerID, options = {} }: FetchWorkerShiftsInput) =>
  new Promise((resolve, reject) => {
    const req = apiRequest({ path: `/admin/workers/${workerID}/shifts`, reqArgs: options })
    handleCall(req, resolve, reject, true, options)
  })
